import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { FaqProps } from "modules/faq/state/actionType";
import ActionButton from "../ActionButton";


export const TableColumns: ColumnDef<FaqProps>[] = [

  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
      accessorFn: (row) => row?.question,
      id: "question",
      cell: (info) => info.getValue(),
      header: () => <span>Question</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.answer,
      id: "answer",
      cell: (info) => info.getValue(),
      header: () => <span >Answer</span>,
      filterFn: "equalsString",
    },
  {
    id: "action",
    cell: ({ row }) => {
      return (
      <div className="flex justify-center items-center gap-2">
        <ActionButton items={row.original} />
      </div>
    )},
    header: () => <span>Actions</span>,
    enableSorting: false,
  },
];
